import type { ThemePayload } from "../../schemas/Theme";
import { isGradientTheme } from "./isGradientTheme";

export function compareThemes(theme: ThemePayload, otherTheme: ThemePayload): boolean {
  return isGradientTheme(theme)
    ? theme.gradient === otherTheme.gradient
    : theme.primaryColor === otherTheme.primaryColor && theme.variation === otherTheme.variation;
}
